import { defineStore } from "pinia";
import { fetchMenuByRole, fetchButtonByRole } from "@/api/system/menu";
import { getParamList } from "@/api/system/param";
import { MenuItem, TabItem } from "@/types/system/menu";
import { ParamManageItem } from "@/types/system/param";
import { TABS, ACCOUNT } from "@/global/constant";
import { Modal } from "ant-design-vue";
import useAccount from "./account";
// import { useRegisterRoutes } from "@/hooks/account";
import cache from "@/utils/cache";
import router from "@/router";
import { fetchDictListByCode } from "@/api/common";
export default defineStore("permission", {
  state: () => {
    return {
      menu: [] as MenuItem[],
      buttons: [] as MenuItem[],
      currentBtns: [] as MenuItem[],
      tablist: [] as TabItem[],
      activeTabKey: "",
      paramsList: [] as ParamManageItem[],
      routeNameMap: {} as Record<string, string>
    };
  },
  actions: {
    initTabs() {
      const allTabs: TabItem[] = cache.getCache(TABS) || [];
      const currentRoleMenuIds = this.menu.reduce((menuIds: string[], item) => {
        (item.children || []).forEach((c) => {
          menuIds.push(c.id);
        });
        return menuIds;
      }, []);
      this.tablist = allTabs.filter((item) => {
        return currentRoleMenuIds.includes(item.key);
      });
    },
    createTab(item: TabItem) {
      if (!this.tablist.some((t) => t.key === item.key)) {
        this.tablist.push(item);
      }
    },
    setActiveTabKey(key: string) {
      this.activeTabKey = key;
    },
    tabClear(type: "closeAll" | "closeOther") {
      if (type === "closeAll") {
        // closeAll 清除所有tab
        this.tablist.length = 0;
        fetchDictListByCode("dashbord-user")
          .then((res) => {
            const account = useAccount();
            if (res.data[0].dictKey.split(",").includes(account.userInfo.id)) {
              router.push("/workbench/index");
            } else {
              router.push("/home");
            }
          })
          .catch(() => {
            router.push("/home");
          });
      } else {
        // closeOther 清除其它所有tab
        this.tablist = this.tablist.filter((t) => t.key === this.activeTabKey);
      }
    },
    tabClose(key: string) {
      this.tablist = this.tablist.filter((t) => t.key !== key);
      if (this.tablist.length === 0) {
        fetchDictListByCode("dashbord-user")
          .then((res) => {
            const account = useAccount();
            if (res.data[0].dictKey.split(",").includes(account.userInfo.id)) {
              router.push("/workbench/index");
            } else {
              router.push("/home");
            }
          })
          .catch(() => {
            router.push("/home");
          });
      }
    },
    mapTab(parentPath: string, childPath: string) {
      const menu = this.menu.find((item) => item.path === parentPath);
      const subMenu = menu?.children.find((item) => item.path === childPath);
      if (subMenu) {
        this.createTab({
          title: subMenu.name,
          key: subMenu.id,
          path: subMenu.path
        });
        this.setActiveTabKey(subMenu.id);
      }
    },
    initMenu() {
      return fetchMenuByRole().then((res) => {
        if (res.code === 200) {
          if (res.data && res.data.length === 0) {
            router.replace("/home");
            Modal.confirm({
              title: "菜单权限提示",
              cancelButtonProps: { style: { display: "none" } } as any,
              content: "你的菜单还没有配置, 请联系管理员!"
            });
            return;
          }
          /* const routes = useRegisterRoutes(res.data);
          for (const item of routes) {
            router.addRoute(item);
          } */

          this.menu = res.data || [];
          this.initTabs();
          this.saveRouteNameMap(this.menu);
        }
      });
    },
    initButton(path: string) {
      return fetchButtonByRole().then((res) => {
        if (res.code === 200) {
          this.buttons = res.data || [];
          this.initCurrentPageBtns(path);
        }
      });
    },
    initCurrentPageBtns(path: string) {
      const current = this.buttons.find((b) => b.path === path);
      this.currentBtns = current?.children || [];
    },
    async initParamsConfigDisabledForm(reg: RegExp) {
      const res = await getParamList({ current: 1, size: 1000 });
      if (res.code === 200) {
        this.paramsList = res.data.records;
      }
      const currentParams = this.paramsList.filter((item) => {
        return reg.test(item.paramKey);
      });
      const disabledFields: string[] = [];
      const account = useAccount();
      if (currentParams.length > 0) {
        for (const item of currentParams) {
          const splitKey = item.paramKey.split(".");
          const splitValue = item.paramValue.split(",");
          const field = splitKey[splitKey.length - 1];
          if (splitValue.includes(account.userInfo.roleName)) {
            disabledFields.push(field);
          }
        }
      }

      return disabledFields;
    },
    async initHideFieldByParmamsConfig(reg: RegExp) {
      const res = await getParamList({ current: 1, size: 1000 });
      if (res.code === 200) {
        this.paramsList = res.data.records;
      }
      const currentParams = this.paramsList.find((item) => {
        return reg.test(item.paramKey);
      });
      const account = useAccount();
      const roleName =
        account.userInfo.roleName || cache.getCache(ACCOUNT)?.roleName;

      const userRole = roleName.split(",");
      const configRole = currentParams?.paramKey
        .slice(currentParams.paramKey.lastIndexOf("."))
        .slice(1)
        .split(",");

      const isControlRule = userRole.every((r: string) =>
        configRole?.includes(r)
      );
      // return currentRoleConfig?.paramValue.split(",");
      return isControlRule ? currentParams?.paramValue.split(",") : [];
    },
    hasPermission(name: string) {
      return this.currentBtns.find((item) => {
        return name === item.path.slice(item.path.lastIndexOf("/") + 1);
      });
    },
    hasPermissionByPath(path: string, name: string) {
      const page = this.buttons.find((c) => c.path === path);
      return (page?.children || []).find((item) => {
        const pathArr = item.path.split("/");
        return name === pathArr.slice(pathArr.length - 1).join("");
      });
    },
    saveRouteNameMap(route: MenuItem[]) {
      for (const item of route) {
        this.routeNameMap[item.path] = item.name;
        if (item.children) {
          this.saveRouteNameMap(item.children);
        }
      }
    }
  }
});
